module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_6005.c152c3b9.png";